import { Box, styled } from "@mui/material";

export const ModalContentContainer = styled(Box)(({ theme }) => ({
	overflow: "auto",
	padding: theme.spacing(3),
	height: "100%",
}));
